import { TransportTimeRange } from '../../../../lib/graphql'

export const houseSearchTransportDurations = [
  { label: '15 min', value: TransportTimeRange.LESS_FIFTEEN_MINUTES },
  { label: '30 min', value: TransportTimeRange.LESS_THIRTY_MINUTES },
  { label: '1h', value: TransportTimeRange.LESS_ONE_HOUR },
  { label: '1h30', value: TransportTimeRange.LESS_ONE_HOUR_AND_THIRTY_MINUTES },
  { label: '2h', value: TransportTimeRange.LESS_TWO_HOURS },
  { label: '3h', value: TransportTimeRange.LESS_THREE_HOURS },
]
